__turbopack_context__.v({
  "customRange": "styles-module__p6PJhG__customRange",
  "customRange10": "styles-module__p6PJhG__customRange10",
  "customRange20": "styles-module__p6PJhG__customRange20",
  "customRange30": "styles-module__p6PJhG__customRange30",
  "customRange40": "styles-module__p6PJhG__customRange40",
  "customRange50": "styles-module__p6PJhG__customRange50",
  "customRange60": "styles-module__p6PJhG__customRange60",
  "customRange70": "styles-module__p6PJhG__customRange70",
  "customRange80": "styles-module__p6PJhG__customRange80",
  "customRange90": "styles-module__p6PJhG__customRange90",
  "sticky-left-shadow": "styles-module__p6PJhG__sticky-left-shadow",
  "unset-shadow": "styles-module__p6PJhG__unset-shadow",
});
